import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Radio} from 'react-bootstrap';
import 'react-select/dist/react-select.css';

export class RadioField extends Component {
    static propTypes = {
        input: PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
            onChange: PropTypes.func,
        }),
        meta: PropTypes.shape({
            touched: PropTypes.bool,
            error: PropTypes.string,
            warning: PropTypes.string,
        }),
    };

    render() {
        const {input: {name, value, onChange}, meta, children, ...radioProps} = this.props;

        return (
            <Radio name={name} value={value} {...radioProps} onChange={onChange}>{children}</Radio>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RadioField.js